import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import axios from 'axios';
import SideNavbar from './helpers/SideNavbar';

const currencySymbol = (code) => {
  const map = { USD: '$', INR: '₹', EUR: '€', GBP: '£' };
  return map[String(code || '').toUpperCase()] || '';
};

const Receipt = () => {
  const [receipt, setReceipt] = useState(null);
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const paymentIntentId = params.get('paymentIntentId');
    const invoiceId = params.get('invoiceId');
    const receiptUrl = params.get('receiptUrl');

    const fetchReceipt = async () => {
      try {
        const res = await axios.get(`${process.env.REACT_APP_API_BASE_URL}/api/receipt`, {
          params: { paymentIntentId, invoiceId }
        });
        if (!res.data?.success) throw new Error(res.data?.error || 'Failed to load receipt');
        setReceipt(res.data.receipt);
      } catch (e) {
        const serverMsg = (e && e.response && (e.response.data?.error || e.response.data?.message)) || '';
        setError(serverMsg || e.message || 'Failed to load receipt');
        // if server fails and we have a fallback receipt url, offer it
        if (receiptUrl) {
          setReceipt({ fallback_url: receiptUrl });
        }
      } finally {
        setLoading(false);
      }
    };

    fetchReceipt();
  }, []);

  const formatAmount = (amt, cur) => `${currencySymbol(cur)}${Number(amt || 0).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;

  return (
    <SideNavbar>
      <div className="card shadow-sm p-4 mt-3" style={{ border: 'none', backgroundColor: '#fff', maxWidth: 900, margin: '0 auto' }}>
        <div style={{ marginBottom: 12 }}>
          <Link
            to="/paymentManager"
            style={{
              display: 'inline-flex',
              alignItems: 'center',
              gap: 10,
              color: '#2e3192',
              textDecoration: 'none',
              fontSize: 20,
              fontWeight: 600
            }}
          >
            <i className="fa fa-arrow-left" aria-hidden="true" style={{ fontSize: 20 }}></i>
            <span>View Receipt</span>
          </Link>
        </div>
        <h3 style={{ color: '#2e3192', marginBottom: 8 }}>Payment Receipt</h3>
        <p style={{ color: '#6c757d', marginTop: 0 }}>This receipt is generated by KnackVibes.</p>

        {loading && <div>Loading receipt…</div>}
        {error && (
          <div className="alert alert-danger">
            {error}
            {receipt?.fallback_url && (
              <div style={{ marginTop: 8 }}>
                <a href={receipt.fallback_url} style={{ color: '#2e3192' }}>Open original Stripe receipt</a>
              </div>
            )}
          </div>
        )}

        {!loading && !error && receipt && (
          <div>
            <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: 16 }}>
              <div>
                <div style={{ fontWeight: 600 }}>Receipt #{receipt.id}</div>
                <div style={{ color: '#6c757d' }}>{new Date(receipt.created).toLocaleString()}</div>
              </div>
              <div style={{ textAlign: 'right' }}>
                <div style={{ fontSize: 18, fontWeight: 700 }}>{formatAmount(receipt.amount, receipt.currency)}</div>
                {receipt.card_brand && (
                  <div style={{ color: '#6c757d' }}>{String(receipt.card_brand).toUpperCase()} •••• {receipt.card_last4}</div>
                )}
              </div>
            </div>

            {receipt.customer && (receipt.customer.name || receipt.customer.email) && (
              <div style={{ marginBottom: 16 }}>
                <div style={{ fontWeight: 600 }}>Billed To</div>
                <div>{receipt.customer.name}</div>
                <div style={{ color: '#6c757d' }}>{receipt.customer.email}</div>
              </div>
            )}

            {Array.isArray(receipt.lines) && receipt.lines.length > 0 && (
              <div style={{ marginBottom: 16 }}>
                <div style={{ fontWeight: 600, marginBottom: 8 }}>Summary</div>
                <ul style={{ margin: 0, paddingLeft: 18 }}>
                  {receipt.lines.map((l, i) => (
                    <li key={i}>
                      <span>{l.description || 'Charge'}</span>
                      <span style={{ float: 'right' }}>{formatAmount(l.amount, l.currency || receipt.currency)}</span>
                    </li>
                  ))}
                </ul>
              </div>
            )}

            <div style={{ borderTop: '1px solid #eee', paddingTop: 12, display: 'flex', justifyContent: 'space-between' }}>
              <div style={{ color: '#6c757d' }}>Status: {String(receipt.status || '').toUpperCase()}</div>
              {receipt.receipt_url && (
                <a href={receipt.receipt_url} target="_blank" rel="noreferrer" style={{ color: '#2e3192' }}>View Stripe Receipt</a>
              )}
              {receipt.fallback_url && !receipt.receipt_url && (
                <a href={receipt.fallback_url} target="_blank" rel="noreferrer" style={{ color: '#2e3192' }}>View Stripe Receipt</a>
              )}
            </div>

            <div style={{ marginTop: 16, color: '#6c757d' }}>
              Questions? Contact us at <a href="mailto:vibes@knackhook.com" style={{ color: '#2e3192' }}>vibes@knackhook.com</a>.
            </div>
          </div>
        )}
      </div>
    </SideNavbar>
  );
};

export default Receipt;


